import React from "react";
import ModeSelectionContainer from "../../containers/TransportationContainer/ModeSelectionContainer";

const ModeSelectionPage = () => {
  return <ModeSelectionContainer />;
};

export default ModeSelectionPage;
